// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7d21db03","169":"80970b92"}[chunkId] + ".chunk.js";
};